import React, { useState } from 'react'
import { Modal } from 'antd';


const LINK = "https://www.youtube.com/embed/skAa-JpWvbQ"
const IMG_LINK = "https://img.youtube.com/vi/skAa-JpWvbQ/mqdefault.jpg"
const LINK2 = "https://www.youtube.com/embed/M9in4kXsTZk"
const IMG_LINK2 = "https://img.youtube.com/vi/M9in4kXsTZk/mqdefault.jpg"


export default function ProductVideo({ type, productId }) {
    const [showModal, setShowModal] = useState(false)
    const [videoLink, setVideoLink] = useState("")
    const openModal = (link) => {
        setShowModal(true)
        setVideoLink(link)
    }

    return (
        <div>
            <div className="mx-3 mb-4 md:ml-0 px-3 py-2 bg-white rounded shadow">
                <div className="mx-3 mb-3">
                    <h1 className="text-2xl font-semibold text-gray-700 border-b border-gray-200">Videos</h1>
                </div>

                <div className="flex flex-wrap flex-col md:flex-row justify-center md:justify-start items-center m-3 pt-2">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a 
                        className="mr-8 mb-8 flex items-center justify-center bg-cover bg-no-repeat bg-center overflow-hidden text-gray-200 opacity-75 rounded hover:shadow-xl hover:opacity-100 hover:text-white" style={{backgroundImage: `url(${IMG_LINK})`, width: "45vh", height: "30vh"}}
                        onClick={ () => openModal(LINK) }
                        >
                        <svg className="w-24 h-24" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd"></path></svg>
                    </a>

                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a 
                        className="mr-8 mb-8 flex items-center justify-center bg-cover bg-no-repeat bg-center overflow-hidden text-gray-200 opacity-75 rounded hover:shadow-xl hover:opacity-100 hover:text-white" style={{backgroundImage: `url(${IMG_LINK2})`, width: "45vh", height: "30vh"}}
                        onClick={ () => openModal(LINK2) }
                    >
                        <svg className="w-24 h-24" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd"></path></svg>
                    </a>

                </div>
            </div>

            <Modal
                centered
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
                width="auto"
                closeIcon={null}
                style={{ padding: 0 }}
                bodyStyle={{padding: 0}}
            >
                <div className="" style={{transform: "scale(1.3)"}}>
                    {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                    <iframe className="h-64 w-full" allowFullScreen="allowFullScreen" frameBorder="0" src={videoLink}></iframe>
                </div>
            </Modal>

        </div>
    )
}
